<h5
    class="mb-2 appTooltip"
    appTooltip="{{consts.TOOLTIP_MESSAGE}}"
    tooltipPosition="right"
>
    {{consts.TITLE}}
    <mat-icon svgIcon="hub_info"></mat-icon>
</h5>
<div class="row">
    <div class="col-lg-2 calender-banner">
        <mat-icon
            [inline]="true"
            svgIcon="hub_calendar"
        >
        </mat-icon>
        <h2>{{consts.LABEL_MAIN}}</h2>
    </div>
    <div class="col-lg-10 calender-content">
        <h3>{{consts.LABEL_SUB}}</h3>
        <div class="events-list" >
            <div *ngFor="let event of eventsWithInterval$ | async" class="event-row">
                <mat-icon svgIcon="hub_calendar"></mat-icon>
                <div class="event-title col">
                    <a class="event-subject" (click)="openLink(event.webUrl)">
                        {{event.subject}}
                    </a>
                    <p class="event-datetime">
                        {{event.start}} - {{event.end}} {{event.location}}
                    </p>
                </div>
                <button
                    class="event-button"
                    *ngIf="event.showButton"
                    mat-raised-button
                    (click)="openLink(event.joinUrl)"
                    appInsightsTrack
                    [eventData]="{title: event.subject, link: event.joinUrl}"
                    loc="Calendar"
                >
                    {{event.action}}
                </button>
            </div>
        </div>
    </div>
</div>
